import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Lightweight markdown renderer with bespoke, dark-mode-aware styling (no
// tailwind-typography dependency). Used to render blog article bodies.
export default function Markdown({ children, className = "" }) {
  return (
    <div className={`text-slate-700 dark:text-slate-300 leading-relaxed ${className}`} data-testid="markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h1 className="font-display text-3xl font-semibold text-slate-900 dark:text-slate-50 mt-10 mb-4 tracking-tight" {...p} />,
          h2: ({ node, ...p }) => <h2 className="font-display text-2xl font-semibold text-slate-900 dark:text-slate-50 mt-10 mb-3 tracking-tight" {...p} />,
          h3: ({ node, ...p }) => <h3 className="font-display text-lg font-semibold text-slate-900 dark:text-slate-100 mt-8 mb-2" {...p} />,
          p: ({ node, ...p }) => <p className="text-base mb-5" {...p} />,
          ul: ({ node, ...p }) => <ul className="list-disc pl-6 space-y-2 mb-5 marker:text-teal-600 dark:marker:text-teal-400" {...p} />,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-6 space-y-2 mb-5" {...p} />,
          li: ({ node, ...p }) => <li className="text-base" {...p} />,
          strong: ({ node, ...p }) => <strong className="font-semibold text-slate-900 dark:text-slate-100" {...p} />,
          a: ({ node, ...p }) => <a className="text-teal-700 dark:text-teal-400 underline underline-offset-2 hover:text-teal-800 dark:hover:text-teal-300" target="_blank" rel="noopener noreferrer" {...p} />,
          blockquote: ({ node, ...p }) => <blockquote className="border-l-4 border-teal-500 pl-4 italic text-slate-600 dark:text-slate-400 my-5" {...p} />,
          code: ({ node, ...p }) => <code className="px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-800 font-mono text-sm" {...p} />,
          hr: () => <hr className="my-8 border-slate-200 dark:border-slate-800" />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
